import angular from 'angular';
import uibModal from 'angular-ui-bootstrap/src/modal';
import Context from './../../Creator/Context/Context';

const HEADER_HEIGHT = 100;
const SCROLL_ZONE_HEIGHT = 60;

/**
 * @memberOf cms.input.edit.form
 * @property {object}   bindings.errors       Form errors object
 * @property {string}   bindings.label        Input label and/or placeholder
 * @property {string}   bindings.buttonTitle  Button label, default "Choose file"
 * @property {array}    bindings.model        Model array reference
 */
let cmsInputEditForm = {
    template: require('./editFormButton.html'),
    bindings: {
        errors: '<',
        label: '@',
        helper: '@',
        buttonTitle: '@',
        model: '=',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@'
    },

    controller: function ($scope, $uibModal) {

        this.openEditFormModal = (model) => {
            let scroll = $(document).scrollTop();
            $uibModal.open({
                scope: $scope,
                animation: true,
                template: require('./editForm.html'),
                size: 'lg',
                resolve: {model: () => model},
                controller: ($scope, model) => {

                    $scope.context = new Context();
                    $scope.context.setDragularScope($scope);
                    $scope.context.setClickOutsideEnabled(false);

                    $scope.dragularScope = $scope.context.getDragularScope();
                    $scope.context.clearCurrentElement();
                    $scope.model = model;
                    $scope.parentModel = {parentModel: model};

                    $scope.onFocus = (input) => {
                        $scope.context.setCurrentElement(input);
                    };

                    $scope.dragularScope.$on('sections-library.drop-model', () => {
                        angular.forEach($scope.model.content, (val, key) => {

                            if (!val.$$hashKey) {
                                if (!$scope.model.content[key].config) {
                                    $scope.model.content[key].config = {};
                                }
                                $scope.model.content[key].config.key = $scope.model.content[key].type + Math.floor(Math.random() * (Math.pow(2, 30) - 1) + 1);
                                $scope.onFocus($scope.model.content[key]);
                            }
                        });
                    });

                    $scope.isSelected = (input) => {
                        return $scope.context.getCurrentElement() === input;
                    };

                    $scope.findPosition = (input) => {
                        let position = -1;
                        $scope.model.content.forEach((el, key) => {

                            if (el.$$hashKey === input.$$hashKey) {
                                position = key;
                            }
                        });
                        return position;
                    };

                    $scope.dragularScope.$on('sections-library.drag', function (el, target, source) {
                        document.documentElement.addEventListener('mousemove', scrollFn);

                    });

                    $scope.dragularScope.$on('sections-library.dragend', function (el, target, source) {
                        document.documentElement.removeEventListener('mousemove', scrollFn);
                        clearInterval(timer);
                    });


                    let timer = null;

                    let scrollFn = (e) => {
                        let height = $('.form-setting__inputs-container').outerHeight(true);
                        if (timer) {
                            clearInterval(timer);
                        }

                        let fn = () => {
                            if (e.clientY > height - SCROLL_ZONE_HEIGHT) {
                                $('.form-setting__inputs-container')[0].scrollTop += 10;
                            } else if (e.clientY < HEADER_HEIGHT + SCROLL_ZONE_HEIGHT) {
                                $('.form-setting__inputs-container')[0].scrollTop -= 10;
                            }
                        };

                        fn();
                        timer = setInterval(fn, 20);
                    };
                }
            }).result.then(() => {
                $(document).scrollTop(scroll);
            }).catch(() => {
                $(document).scrollTop(scroll);
            });
        }
    }
};

/**
 * Edit form control
 * @namespace cms.input.edit.form
 */
export default angular.module('cms.input.edit.form', [uibModal]).component('cmsInputEditForm', cmsInputEditForm).name;



// WEBPACK FOOTER //
// ./src/cmsCore/Controls/EditFormControl/CmsEditForm.js